import Stack from '@mui/material/Stack';
import RollUpTools from 'src/components/rollup-tools';
import { usePopover } from 'src/components/custom-popover';
import { useResponsive } from 'src/hooks/use-responsive';
import { AccountPopover, GoalsPopover, NotificationsPopover, ScenariosPopover } from '../_common';
import RefreshButton from './RefreshButton';

export default function ContextToolBar() {
  const mdUp = useResponsive('up', 'md');

  const popover = usePopover();

  return (
    <Stack
      flexGrow={1}
      direction="row"
      sx={{ top: 0 }}
      // alignItems={{ md: 'flex-end', sm: 'space-between' }}
      alignItems="center"
      spacing={{ xs: 0.5, sm: 1 }}
    >
      <RollUpTools />
      <ScenariosPopover />
      {mdUp && <NotificationsPopover onClick={popover.onClose} />}
      {mdUp && <RefreshButton />}
      {mdUp && <GoalsPopover />}
      <AccountPopover />

      {/* <LanguagePopover /> */}
      {/* <ContactsPopover /> */}
      {/* <SettingsButton /> */}
    </Stack>
  );
}
